import { Modal, Table } from 'react-bootstrap'
import { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import TrocasDevolucoesService from '../../../services/database/TrocasDevolucoesService'

import './styles.css'
import { formatDate } from '../../../utils/formatDate'
import { CustomSpinner } from '../../../components/CustomSpinner'
import { formatPrice } from '../../../utils/formatPrice'
import { CaretDown, CaretUp } from 'react-bootstrap-icons'
import { useOrderTable } from '../../../hooks/useOrderTable'

export function ModalConsultarSaldo({ isOpen, onClose, pessoa }) {
  const [movimentacoes, setMovimentacoes] = useState([])
  const [isMovimentacaoLoading, setIsMovimentacaoLoading] = useState(true)

  const {
    sortedArray: sortedMovimentacao,
    check,
    handleOrganize,
  } = useOrderTable(movimentacoes, 'id')

  const loadMovimentacoes = useCallback(async () => {
    setIsMovimentacaoLoading(true)

    try {
      const movimentacoesData = await TrocasDevolucoesService.getAll(
        pessoa.cod_pessoa,
      )

      setMovimentacoes(movimentacoesData)
    } catch (err) {
      console.log(`Erro ao listar as movimentações do cliente:`, err)
      toast.error('Erro ao listar as movimentações do cliente!')
    } finally {
      setIsMovimentacaoLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pessoa])

  useEffect(() => {
    loadMovimentacoes()
  }, [loadMovimentacoes])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="modal-consultar-saldo-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Consultando Movimentações de <strong>{pessoa?.pes_razao}</strong>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isMovimentacaoLoading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CustomSpinner color="#006fff" />
          </div>
        ) : (
          <>
            {sortedMovimentacao.length === 0 ? (
              <p>Sem Movimentações!</p>
            ) : (
              <Table
                striped
                bordered
                hover
                responsive
              >
                <thead>
                  <tr>
                    <th onClick={() => handleOrganize('id')}>
                      <span>ID</span>
                      <CaretUp color={check('id', 'asc')} />
                      <CaretDown color={check('id', 'desc')} />
                    </th>

                    <th onClick={() => handleOrganize('id_pedido')}>
                      <span> ID Pedido</span>
                      <CaretUp color={check('id_pedido', 'asc')} />
                      <CaretDown color={check('id_pedido', 'desc')} />
                    </th>

                    <th>
                      <span> ID Cliente</span>
                    </th>

                    <th>
                      <span>Quantidade</span>
                    </th>

                    <th onClick={() => handleOrganize('valor_unitario')}>
                      <span> Valor Unitário</span>
                      <CaretUp color={check('valor_unitario', 'asc')} />
                      <CaretDown color={check('valor_unitario', 'desc')} />
                    </th>

                    <th onClick={() => handleOrganize('valor_total')}>
                      <span> Valor Total</span>
                      <CaretUp color={check('valor_total', 'asc')} />
                      <CaretDown color={check('valor_total', 'desc')} />
                    </th>

                    <th>
                      <span>Acréscimo Saldo</span>
                    </th>

                    <th onClick={() => handleOrganize('data_devolucao')}>
                      <span> Data de Devolução</span>
                      <CaretUp color={check('data_devolucao', 'asc')} />
                      <CaretDown color={check('data_devolucao', 'desc')} />
                    </th>

                    <th>
                      <span> SKU Produto</span>
                    </th>

                    <th>
                      <span> ID Funcionário</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {sortedMovimentacao.map((movimentacao) => (
                    <tr key={movimentacao.id}>
                      <td>{movimentacao.id}</td>
                      <td>{movimentacao.id_pedido}</td>
                      <td>{movimentacao.id_cliente}</td>
                      <td>{movimentacao.quantidade}</td>
                      <td>{formatPrice(movimentacao.valor_unitario)}</td>
                      <td>{formatPrice(movimentacao.valor_total)}</td>
                      <td>
                        {movimentacao.acrescimo_saldo === 'S' ? 'Sim' : 'Não'}
                      </td>
                      <td>{formatDate(movimentacao.data_devolucao)}</td>
                      <td>{movimentacao.sku_produto}</td>
                      <td>{movimentacao.id_funcionario}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
